import * as React from "react";
import styles from "./styles.module.scss";
import { EventVendorQuery } from "@src/@types/api.d";
import Icon from "@src/components/Icon";
import { decodeHtmlEntities } from "@src/utils/general";

type Props = {
  eventId: number;
  eventVendorData: EventVendorQuery;
};

const Vendors: React.FC<Props> = ({ eventId, eventVendorData }) => {
  return eventVendorData?.eventVendor &&
    eventVendorData?.eventVendor.length !== 0 ? (
    <div className="px-4 bg-[rgba(236,228,237,1)]">
      <section className="py-[5rem]">
        <h3 className="font-silver text-4xl sm:text-5xl capitalize text-center text-black mb-4 lg:mb-8">
          Our Vendors
        </h3>
        <div className="flex flex-wrap justify-center gap-8">
          {eventVendorData?.eventVendor?.map((vendor, index) => {
            const decodedName = decodeHtmlEntities(vendor?.name);
            const decodedRole = decodeHtmlEntities(vendor?.role);
            const decodedEmail = decodeHtmlEntities(vendor?.email);
            const decodedInstagramHandle = decodeHtmlEntities(
              vendor?.instagram_handle
            );

            return (
              <div
                key={`vendors-home-page-${index}`}
                className="p-4 flex flex-col justify-center items-center gap-2 lg:gap-4 w-full text-black max-w-xs vendor-card"
              >
                <div className="font-sans text-xl">{decodedName}</div>
                <p className="font-sans font-light text-lg">{decodedRole}</p>
                <p className="font-sans font-light text-lg">{decodedEmail}</p>
                <div className="flex gap-2 items-center">
                  {/* {!!vendor?.facebook && (
                    <a
                      target="_blank"
                      href={
                        vendor?.facebook.includes("@")
                          ? `https://www.facebook.com/${
                              vendor?.facebook.split("@")[1]
                            }/`
                          : `https://www.facebook.com/${vendor?.instagram_handle}/`
                      }
                      rel="noopener noreferrer"
                      className="text-white"
                    >
                      <Icon iconName="facebook" />
                    </a>
                  )}

                  {!!vendor?.twitter && (
                    <a
                      target="_blank"
                      href={
                        vendor?.twitter.includes("@")
                          ? `https://www.x.com/${
                              vendor?.twitter.split("@")[1]
                            }/`
                          : `https://www.x.com/${vendor?.twitter}/`
                      }
                      rel="noopener noreferrer"
                      className=""
                    >
                      <Icon iconName="twitterWhite" />
                    </a>
                  )} */}

                  {!!decodedInstagramHandle && (
                    <a
                      target="_blank"
                      href={
                        decodedInstagramHandle.includes("@")
                          ? `https://www.instagram.com/${
                              decodedInstagramHandle.split("@")[1]
                            }/`
                          : `https://www.instagram.com/${decodedInstagramHandle}/`
                      }
                      rel="noopener noreferrer"
                      className=""
                    >
                      <Icon iconName="instagram" />
                    </a>
                  )}
                </div>
              </div>
            );
          })}
        </div>
        <div
          className="mt-10 flex justify-center h-5 w-full relative overflow-hidden"
          style={{
            backgroundImage: `url('/images/Frame (3).svg')`,
            backgroundSize: "cover",
            backgroundRepeat: "repeat-x",
            backgroundPosition: "top left",
            transform: "scaleY(-1)",
          }}
        ></div>
      </section>
    </div>
  ) : (
    <></>
  );
};

export default Vendors;
